<template>
    <component :is="tag"
               v-bind="imageSrc"
               :alt="alt"
               :class="imageClass">
        <slot />
    </component>
</template>

<script>
    import { wpMediaApi } from '../utils/api';
    import { EventBus } from '../utils/eventBus';
    import _get from 'lodash/get';
    import _extend from 'lodash/extend';

    const imagesProcessed = {};

    export default {
        name: "WpImage",
        props: {
            lWidth: {
                type: Number,
                default: 160,
            },
            lHeight: {
                type: Number,
                default: 40
            },
            image: {
                type: Number | Boolean,
                required: true
            },
            sizeSD: {
                type: String,
                default: 'sd'
            },
            sizeHD: {
                type: String,
                default: 'full'
            },
            tag: {
                type: String,
                default: 'img',
            },
            isBackground: {
                type: Boolean,
                default: false,
            },
            dontTrack: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                endpoint: `${plugin_wp.root}wp/v2/media/`,
                loaded: false,
                images: imagesProcessed,
                loadedImageID: 0,
                alt: '',
                category: [],
                url: '',
                urlHD: '',
                isHD: false
            }
        },
        created() {
            if (!this.dontTrack) {
                EventBus.addImage();
            }
        },
        computed: {
            imageClass() {
                return 'loaded';
            },
            imageSrc() {
                const url = this.hdUrl || this.url;
                if (!url) return null;
                return this.isBackground ? { style: { backgroundImage: `url(${url})` } } : { src: url };
            },
        },
        asyncComputed: {
            async url() {
                const image = await this.imageApiData;
                if (!image) return null;
                this.category = image.acf && image.acf.category;
                this.alt = image.title && image.title.rendered;
                const sdUrl = _get(image, `media_details.sizes.${this.sizeHD}.source_url`, '');

                if (!sdUrl) return image.source_url;

                await this.loadImage(sdUrl);
                this.$emit('sd-loaded');

                if (!this.dontTrack) {
                    this.$nextTick(() => EventBus.imageLoaded());
                }
                return sdUrl;
            },
            async imageApiData() {
                if ( this.images[this.image] ) {
                    return this.images[this.image]
                }

                return this.images[this.image] = await wpMediaApi.get(`${this.image}`).then(res => res.data);
            },
            async hdUrl() {
                const image = await this.imageApiData;
                if (!image) return null;

                const hdUrl = _get(image, `media_details.sizes.${this.sizeHD}.source_url`, '');

                if (!hdUrl) return image.source_url;
                await this.loadImage(hdUrl);
                this.$emit('hd-loaded');
                return hdUrl;
            },
        },
        watch: {
            url: {
                immediate: true,
                handler(url, oldUrl) {
                    if (!url) return;
                    this.$emit('loaded', this.loadedImageID)
                }
            }
        },
        methods: {
            loadImage(src) {
                return new Promise((resolve, reject) => {
                    const image = new Image();
                    image.onload = resolve;
                    image.onerror = reject;
                    image.src = src;
                });
            },
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>

    .module-background {
        background-color: gray;
        background-repeat: no-repeat;
        background-position: top center;
        background-size: cover;
        height: 100%;
        min-height: 100vh;
        position: absolute;
        top: 0;
        width: 100%;
        z-index: -1;

        @media screen and (max-height: 500px){
            min-height: 500px;
        }
    }

    img {
        filter: blur(3px);
        transition: filter 0.3s;
        vertical-align: top;
        &.loaded {
            filter: blur(0);
        }
    }

</style>